import { render } from "./TooltipUserAvatar.vue?vue&type=template&id=09958d89&scoped=true"
import script from "./TooltipUserAvatar.vue?vue&type=script&lang=js"
export * from "./TooltipUserAvatar.vue?vue&type=script&lang=js"

import "./TooltipUserAvatar.vue?vue&type=style&index=0&id=09958d89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09958d89"]])

export default __exports__